<template>
  <v-container fluid>
    <!-- Search bar -->
    <v-row align="center" class="mb-4 mr-2 ml-2">
      <v-text-field v-model="search" label="Recherchez une entreprise" single-line hide-details></v-text-field>
    </v-row>
    <!-- Data table for displaying exclusions -->
    <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune entreprise trouvée"
      :items="this.$store.getters['Auth/getExclusion']" class="elevation-1 mb-5 px-5">
      <!-- Slot for custom row rendering -->
      <template v-slot:[`item.dateDebutSanction`]="{ item }">{{
        item.dateDebutSanction | moment("DD MMMM YYYY")
      }}</template>

      <template v-slot:[`item.dateFinSanction`]="{ item }">{{
        item.dateDebutSanction | moment("DD MMMM YYYY")
      }}</template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    search: "",
    headers: [
      { text: "Nom du cabinet", align: "start", sortable: false, value: "nomCabinet" },
      { text: "Reference de la décision", sortable: false, value: "referenceDecision" },
      { text: "Motif de l’exclusion", sortable: false, value: "motifExclusion" },
      { text: "Date de début de sanction", sortable: false, value: "dateDebutSanction" },
      { text: "Date de fin de sanction", sortable: false, value: "dateFinSanction" },

    ],
  }),
  created() {
    this.$store.dispatch("Auth/loadAllExclusions");
    // let Virt = [];

    // Virt = JSON.parse(localStorage.getItem("userData"));
    // this.profile = Virt.profile.status;
  },
  methods: {
    ...mapActions({
      loadAllExclusions: "Auth/loadAllExclusions",
    }),
  }
};
</script>

<style></style>